import formatDistance from "date-fns/formatDistance";
import parseISO from "date-fns/parseISO";
export function formatBadgeCount(count) {
  return count > 9 ? "9+" : count;
}
export function formatTimestamp(ts) {
  try {
    var parsedTs = parseISO(ts);
    var formatted = formatDistance(parsedTs, new Date(), {
      addSuffix: true
    });
    return formatted;
  } catch (e) {
    return ts;
  }
}
export function toSentenceCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function renderNodeOrFallback(node, fallback) {
  return node !== undefined ? node : fallback;
}
/*
  Used to build a consistent key for the KnockFeedProvider so that React knows when
  to trigger a re-render of the context when a key property changes.
*/

export function feedProviderKey(userFeedId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return [userFeedId, options.source, options.tenant, options.has_tenant, options.archived].filter(f => f !== null && f !== undefined).join("-");
}
//# sourceMappingURL=utils.js.map